import { TransformedCustomViewContainer } from "../../components/transformed_custom_view";
import { PivotControl } from "../../constants/pivot_control_options";
import { defaultConfig } from "./default_config";
import { paramsToTransformArgs } from "./params_to_transform_args";
import { createTransferRecommendationsMatrix } from "./matrix_creator";

export const TransferRecommendationsContainer = () => {
  return (
    <TransformedCustomViewContainer
      viewControllerConfig={{
        datasetName: "transfers",
        transformId: "transfer_recommendations_matrix",
        folder: "outputs",
        title: "Transfer Planning",
        dateHierarchyColumnFilter: { week: "week", month: "month" },
        excludedSegmentationsFilter: ["from_location", "to_location", "order_id", "inventory_id"],
        measureColumnFilter: {},
        excludedFilterColumnFilter: [],
        showControls: [
          PivotControl.DateHierarchy,
          PivotControl.SegmentSelectMulti,
          PivotControl.FilterBy,
          PivotControl.DatePeriodPicker,
          PivotControl.StoreAsDefault,
          PivotControl.Download,
        ],
        paramsToTransformArgs,
        getMatrix: createTransferRecommendationsMatrix,
        excludeDetailRows: true,
      }}
      defaultConfig={defaultConfig}
    />
  );
};
